interface Props {
  onCancel: () => void;
  onConfirm: () => void;
}

export default function RestartModal({ onCancel, onConfirm }: Props) {
  return (
    <div className="restart-modal" role="dialog" aria-modal="true">
      <div className="restart-modal-content">
        <p>This will erase your current progress. Continue?</p>
        <div className="restart-modal-actions">
          <button className="restart-btn restart-cancel" onClick={onCancel}>Cancel</button>
          <button className="restart-btn restart-confirm" onClick={onConfirm}>Restart</button>
        </div>
      </div>
    </div>
  );
}
